import React from 'react'

const PaperPlaneIcon = () => {
  return (
    <img
      src="/paper-plane-icon.svg"
      width={28}
      height={28}
      alt="Paper plane icon"
    />
  )
}

export default PaperPlaneIcon
